import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["minRange", "maxRange", "minInput", "maxInput", "fill"]

  connect() {
    this._updateFill()
  }

  syncFromRange() {
    let min = +this.minRangeTarget.value
    let max = +this.maxRangeTarget.value

    if (min > max) {
      min = max
      this.minRangeTarget.value = min
    }
    if (max < min) {
      max = min
      this.maxRangeTarget.value = max
    }

    this.minInputTarget.value = min
    this.maxInputTarget.value = max
    this._updateFill()
  }

  syncFromInput(event) {
    const step = 5
    const snap = (v) =>
      Math.round(Math.max(0, Math.min(100, +v || 0)) / step) * step

    if (event.target === this.minInputTarget) {
      const snapped = snap(this.minInputTarget.value)
      this.minInputTarget.value = snapped
      this.minRangeTarget.value = snapped
    } else {
      const snapped = snap(this.maxInputTarget.value)
      this.maxInputTarget.value = snapped
      this.maxRangeTarget.value = snapped
    }
    this._updateFill()
  }

  _updateFill() {
    const min = +this.minRangeTarget.value
    const max = +this.maxRangeTarget.value
    this.fillTarget.style.left = min + "%"
    this.fillTarget.style.right = 100 - max + "%"
  }
}
